// extracted by css-extract-rspack-plugin
export default {"banner":"wEKfEfLyhTs7qvaR__banner___","bannerContainer":"w75uS5dyHo3xqANq__bannerContainer___"};